import React from "react";

type IconProps = {
    className?: string;
    color?: string;
};

export const CheckIcon = ({ className, color }: IconProps) => {
    const fillColor = color ? color : "white";
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            className={className}
        >
            <mask
                id="mask0_2881_6924"
                style={{ maskType: "alpha" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="48"
                height="48"
            >
                <rect width="48" height="48" fill="var(--color-white-500)" />
            </mask>
            <g mask="url(#mask0_2881_6924)">
                <path
                    d="M19.7505 29.167L34.3755 14.5837C34.7213 14.2503 35.169 14.0837 35.7184 14.0837C36.2676 14.0837 36.7227 14.2481 37.0838 14.577C37.4449 14.9337 37.6255 15.3962 37.6255 15.9645C37.6255 16.5328 37.4449 16.9892 37.0838 17.3337L21.1255 33.2503C20.7594 33.6115 20.2998 33.792 19.7467 33.792C19.1937 33.792 18.7505 33.6115 18.4172 33.2503L10.9172 25.792C10.556 25.4253 10.3755 24.9656 10.3755 24.4128C10.3755 23.8601 10.5538 23.4031 10.9105 23.042C11.2672 22.6809 11.7227 22.5003 12.2772 22.5003C12.8316 22.5003 13.2949 22.6809 13.6672 23.042L19.7505 29.167Z"
                    fill={fillColor}
                />
            </g>
        </svg>
    );
};
